module.exports = __webpack_public_path__ + "8f42679c25636b6ec96f09a9fd627607.jpg";